import { render, staticRenderFns } from "./ConfirmDeleteContract.vue?vue&type=template&id=66f1d242&"
import script from "./ConfirmDeleteContract.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports